// ----------------------------------------------------------------------
// <copyright file="Izenda.ConvertToDatimeFormat.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import moment from 'moment';
import {
  DATE_TIME_FORMAT as DEFAULT_FORMAT,
  DATE_TIME_FORMAT_WITH_TIMEZONE as DEFAULT_FORMAT_WITH_TIMEZONE
} from 'logic/data/Izenda.AppGlobalConstants';
import {
  DEFAULT_FORMAT_PATTERN,
  DATE_TIME_FORMAT as DATE_TIME_FORMATS,
  GROUP_BY,
  DAY_OF_WEEK_VALUES
} from 'logic/data/Izenda.TimeFormatConstants';
import uiState from 'logic/Izenda.UiState';
import { isNil, isNaN, isDate, isNumber, isString, nth, getOr, get } from 'lodash/fp';
/**
 *
 * @param pattern
 * @param value
 * @param isFormatted
 * @param inputFormat
 * @returns {*}
 */
export default function(pattern: any, value: any, isFormatted: boolean, inputFormat: any) {
  pattern = pattern || DEFAULT_FORMAT_PATTERN;

  if (isNil(value)) {
    return null;
  }

  if (value === '') {
    return '';
  }

  // For special case, pattern = 'Day of Week'
  // Start day of Week in momentjs = 0 but in BE it will be 1
  // Currently, only 'en' is loaded into moment package.
  if (pattern === 'Day of Week') {
    const dow = parseInt(value);
    if (!isNaN(dow)) {
      if (dow >= 1 && dow <= 7) {
        value = nth(value, DAY_OF_WEEK_VALUES);
      }
    }
  }

  let dataTime = '';
  let momentDateTime;
  const outputFormat = getOr(uiState.currentUser.dateFormat, 'MOMENT_OUTPUT', DATE_TIME_FORMATS[pattern]);

  if (isDate(value)) {
    momentDateTime = moment(value);
  } else if (inputFormat) {
    momentDateTime = moment(value, inputFormat);
  } else {
    const patternGroupBy = get('GROUP_BY', DATE_TIME_FORMATS[pattern]);
    const groupByInputFormat = get('GROUP_BY_EXPECTED_FORMAT', GROUP_BY[patternGroupBy]);
    momentDateTime = moment(value, groupByInputFormat ? [groupByInputFormat, DEFAULT_FORMAT] : DEFAULT_FORMAT);
    !momentDateTime.isValid() && (momentDateTime = moment(value, DEFAULT_FORMAT_WITH_TIMEZONE));
  }

  // special case for day, we don't want to moment js to  use current month,
  // because current month may have only 28 day
  // forcing all case to make sure it will convert to same month if return date object for chart
  if (pattern === 'Day' && ((isString(value) && /^\d{1,2}$/.test(value)) || isNumber(value))) {
    momentDateTime = moment()
      .startOf('year')
      .date(value);
  }

  if (isFormatted === false) {
    // return date object
    return momentDateTime.toDate();
  }
  dataTime = momentDateTime.isValid() ? momentDateTime.format(outputFormat) : value;

  return dataTime;
}



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.ConvertToDateTimeFormat.js